import { useEffect, useState } from "react";

const BASE = process.env.PUBLIC_URL || "";

/**
 * Carga los índices de búsqueda de GES y de medicamentos para alimentar el
 * buscador global (CommandPalette) con contenido, no solo secciones.
 * Degradación elegante: si algo falla, devuelve listas vacías.
 *
 * @returns {{ ges: Array, meds: Array }}
 */
export default function useSpotlightData() {
  const [data, setData] = useState({ ges: [], meds: [] });

  useEffect(() => {
    let activo = true;
    const json = (url) =>
      fetch(url).then((r) => (r.ok ? r.json() : [])).catch(() => []);
    Promise.all([
      json(`${BASE}/ges/indices/busqueda.json`),
      json(`${BASE}/fichas/indices/busqueda.json`),
    ]).then(([ges, meds]) => {
      if (!activo) return;
      setData({
        ges: Array.isArray(ges) ? ges : [],
        meds: Array.isArray(meds) ? meds : [],
      });
    });
    return () => { activo = false; };
  }, []);

  return data;
}
